import BossModel from "@/models/BossModel";
import PublicImage from "@/models/PublicImage/PublicImage";

export default class WebsiteCountryInspiration extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-country-inspiration';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteCountryInspirations';

    static fields() {
		return {
			id: this.number(null).nullable(),
			information: this.attr(null),
			country_id: this.number(null).nullable(),
			public_image_id: this.number(null).nullable(),
            publicImage: this.belongsTo(PublicImage, 'public_image_id'),
		}
	}
}
